import { DataResponse } from '@/common/Response';
import { IBrandResponse } from '@/data/brand/types';
import { Api, ApiOptions } from '@/utils/api';

const brandService = {
  getByDomain: (domain: string, options?: ApiOptions) => {
    return Api.get<DataResponse<IBrandResponse>>(
      `/api/v1/brands/domain/${domain}`,
    );
  },
};

export default brandService;
